// Those constants are required as during sever-side rendering
// we cannot use global browser variables like requestAnimationFrame
// but we can after the React Hydration phase.

// Is in Client Side Rendering Mode
export const IS_CSR = typeof window !== 'undefined';

// Is in Server Side Rendering Mode
export const IS_SSR = !IS_CSR;
